import {
    GET_EQUIPMENT_TYPE,
    SAVE_EQUIPMENT_TYPE
} from "./EquipmentType"

const getEquipmentType = (assetSubTypeId: number) => {
    return ({
        type: GET_EQUIPMENT_TYPE,
        assetSubTypeId: assetSubTypeId
    })
};

const setEquipmentType = (equipmentType: any) => ({
    type: SAVE_EQUIPMENT_TYPE,
    equipmentType: equipmentType
});

export {
    getEquipmentType,
    setEquipmentType
}